import AlertBell from '../../src/legacy/AlertBell.tsx';
export default AlertBell;
